import DynamicForm from "../../components/DynamicForm";

export const YourPage = () => {
  return (
    <DynamicForm />
  );
};